import type { FC } from "react";
import {
	NOTIFICATION_CENTER_TABS,
	type NotificationCenterTab,
} from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { RecentFilters } from "web_myplann/NotificationCenter/FilterScreen/RecentFilters";
import { UpcomingFilters } from "web_myplann/NotificationCenter/FilterScreen/UpcomingFilters";

type Props = {
	activeTab: NotificationCenterTab;
};

export const FilterScreenFilters: FC<Props> = ({ activeTab }) => (
	<>
		{activeTab === NOTIFICATION_CENTER_TABS.Upcoming && <UpcomingFilters />}
		{activeTab === NOTIFICATION_CENTER_TABS.Recent && <RecentFilters />}
	</>
);
